<template>
  <div>

    <!-- HERO -->
    <div
      class="hero-section"
      :style="{
        backgroundImage:
          informations && informations.header_img
            ? 'url(https://admin.asso-refuge.fr/images/' + informations.header_img + ')'
            : 'none'
      }"
    >
      <div class="hero-overlay">
        <h1 class="hero-assoc-title">Les Oubliés de la Run</h1>
        <p class="hero-assoc-sub">Sauvetages de chiens sur le territoire français et les Dom Tom.</p>
        <p class="hero-assoc-label"><i class="fas fa-certificate"></i> Association Loi 1901 reconnue d'utilité générale</p>
      </div>
    </div>



 






    <!-- DERNIERS ARRIVÉS -->
    <div class="adopt-block">
      <div class="adopt-wrap">

        <!-- En-tête -->
        <div class="adopt-head">
          <div class="adopt-head__left">
            <span class="adopt-eyebrow"><i class="fas fa-paw"></i> Adoption</span>
            <h2 class="adopt-title">Nos animaux à adopter</h2>
          </div>
          <router-link to="/animaux" class="adopt-cta">
            Voir tous nos animaux <i class="fas fa-arrow-right"></i>
          </router-link>
        </div>

        <!-- Stats -->
        <div class="adopt-stats">
          <div class="adopt-stat">
            <i class="fas fa-dog adopt-stat__ico"></i>
            <div>
              <strong>{{ chiens.length }}</strong>
              <span>Chiens</span>
            </div>
          </div>
          <div class="adopt-stat">
            <i class="fas fa-heart adopt-stat__ico adopt-stat__ico--red"></i>
            <div>
              <strong>{{ chiens.length + chats.length + nacs.length + ferme.length }}</strong>
              <span>Animaux au total</span>
            </div>
          </div>
       
        </div>

      </div>
      <homeData :chiens="chiens" :chats="chats" />

      <!-- Carousel en dehors du wrap pour garder sa taille d'origine -->

    </div>

    <div id="actuID" class="seperation"></div>

    <!-- ACTUS + FACEBOOK -->
    <div class="adopt-block">
      <div class="adopt-wrap">




          <!-- Colonne droite : actualités du site -->
          <div class="actu-col">
            <div class="adopt-head">
              <div class="adopt-head__left">
                <span class="adopt-eyebrow"><i class="fas fa-newspaper"></i> Actualités</span>
                <h2 class="adopt-title">Les Dernières Actualités</h2>
              </div>
              <router-link to="/actualites" class="adopt-cta">
                Voir tout <i class="fas fa-arrow-right"></i>
              </router-link>
            </div>

            <div class="actu-cards">
              <router-link
                v-for="actu in slicedNews"
                :key="actu.id"
                :to="'/publication/' + actu.id"
                class="news-card"
              >
                <div
                  class="news-card-bg"
                  :style="{ backgroundImage: 'url(https://admin.asso-refuge.fr/images/' + actu.image + ')' }"
                ></div>
                <div class="news-card-gradient"></div>
                <div class="news-card-title">{{ actu.nom }}</div>
              </router-link>
            </div>

        </div>
      </div>
    </div>
  




 

    <div class="seperation"></div>

    <div class="adopt-block">
      <div class="adopt-wrap">
              <!-- En-tête -->
        <div class="adopt-head">
          <div class="adopt-head__left">
            <span class="adopt-eyebrow"><i class="fas fa-paw"></i> Infos</span>
            <h2 class="adopt-title">Contactez l'association</h2>
          </div>
        </div>

        <div class="info-mosaic">

          <!-- MAP -->


          <!-- Email -->
          <div class="icard">
            <div class="icard__head">
              <div class="icard__icon icard__icon--rose"><i class="fas fa-envelope"></i></div>
              <span class="icard__label">Email</span>
            </div>
            <p class="icard__val" v-html="formattedEmail"></p>
          </div>

        </div>

        <div class="info-footnote">
          <i class="fas fa-heart"></i>
          Merci de soutenir nos actions — chaque geste compte.
        </div>
      </div>
    </div>

    <!-- Ancre contact en bas -->
    <div id="contact" class="contact-anchor" aria-hidden="true"></div>

  </div>
</template>

<script setup>
import homeData from '../components/homeData.vue'
</script>

<script>
export default {
  data() {
    return {
      informations: null,
      news: [],
      animaux: [],
      chats: [],
      chiens: [],
      nacs: [],
      ferme: [],
      items: [],
      showMap: false,
      isMobile: false
    }
  },

  mounted() {
    const idSite = this.$idSite

    this.isMobile = window.innerWidth < 600

    fetch(`https://admin.asso-refuge.fr/getInformations/${idSite}`)
      .then(res => res.json())
      .then(data => {
        if (data && data.length) {
          this.informations = data[0]
        }
      })

    fetch(`https://admin.asso-refuge.fr/getNews/${idSite}`)
      .then(res => res.json())
      .then(data => (this.news = data || []))

    fetch(`https://admin.asso-refuge.fr/getAnimal/${idSite}`)
      .then(res => res.json())
      .then(data => {
        this.animaux = data || []
        this.chats = this.animaux.filter(a => a.type === 'chat')
        this.chiens = this.animaux.filter(a => a.type === 'chien')
        this.nacs = this.animaux.filter(a => a.type === 'nacs')
      })

    fetch(`https://admin.asso-refuge.fr/getFermes/${idSite}`)
      .then(res => res.json())
      .then(data => { this.ferme = data || [] })

    // RENDER MAP APRÈS LAYOUT
    this.$nextTick(() => {
      setTimeout(() => {
        this.showMap = true
      }, 150)
    })

    // SDK Facebook
    if (!document.getElementById('facebook-jssdk')) {
      const script = document.createElement('script')
      script.id = 'facebook-jssdk'
      script.async = true
      script.defer = true
      script.crossOrigin = 'anonymous'
      script.src = 'https://connect.facebook.net/fr_FR/sdk.js#xfbml=1&version=v19.0'
      document.head.appendChild(script)
    } else if (window.FB) {
      window.FB.XFBML.parse()
    }
  },

  computed: {
    formattedHorraire() {
      return this.informations?.horraire?.replace(/\r\n/g, '<br>') || ''
    },
    formattedEmail() {
      return this.informations?.email?.replace(/\r\n/g, '<br>') || ''
    },
    formattedAdresse() {
      return this.informations?.address?.replace(/\r\n/g, '<br>') || ''
    },
    formattedPhone() {
      return this.informations?.phone?.replace(/\r\n/g, '<br>') || ''
    },
    slicedNews() {
      return this.news.slice(0, this.isMobile ? 3 : 4)
    }
  }
}
</script>

<style scoped>
/* ══════════════════════════════════════
   HERO OVERLAY
══════════════════════════════════════ */
.hero-overlay {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  padding: 24px 36px;
  background: rgba(0, 0, 0, 0.48);
  backdrop-filter: blur(4px);
  border-radius: 18px;
  color: #fff;
  width: max-content;
  max-width: 90%;
}
.hero-assoc-title {
  margin: 0 0 8px;
  font-size: clamp(22px, 3.5vw, 40px);
  font-weight: 900;
  letter-spacing: -.02em;
  text-shadow: 0 2px 10px rgba(0,0,0,.4);
}
.hero-assoc-sub {
  margin: 0 0 10px;
  font-size: clamp(14px, 1.6vw, 19px);
  font-weight: 600;
  color: rgba(255,255,255,.92);
  text-shadow: 0 1px 6px rgba(0,0,0,.35);
}
.hero-assoc-label {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: clamp(12px, 1.2vw, 15px);
  font-weight: 700;
  letter-spacing: .04em;
  text-transform: uppercase;
  color: #ffd700;
  text-shadow: 0 1px 6px rgba(0,0,0,.4);
}

/* ══════════════════════════════════════
   BLOC ADOPTION
══════════════════════════════════════ */
.adopt-block {
  background: #f7f7f8;
  padding: 48px 0 36px;
}
.adopt-wrap {
  max-width: 80%;
  margin: 0 auto;
  padding: 0 28px;
}

/* En-tête */
.adopt-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.adopt-head__left {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.adopt-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 13px;
  border-radius: 999px;
  background: rgba(32, 106, 203, 0.1);
  color: #c80002;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .04em;
  text-transform: uppercase;
  width: fit-content;
}
.adopt-title {
  margin: 0;
  font-size: clamp(22px, 2.8vw, 34px);
  font-weight: 900;
  letter-spacing: -.025em;
  color: #111;
}

/* CTA */
.adopt-cta {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 11px 18px;
  border-radius: 12px;
  background: #fff;
  border: 1.5px solid #e0e0e0;
  color: #111;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
  transition: border-color .15s, box-shadow .15s;
}
.adopt-cta:hover {
  border-color: #bbb;
  box-shadow: 0 4px 14px rgba(0,0,0,.08);
}

/* Stats */
.adopt-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 4px;
}
@media (max-width: 900px) {
  .adopt-stats { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 560px) {
  .adopt-stats { grid-template-columns: repeat(2, 1fr); gap: 8px; }
}
.adopt-stat {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  gap: 8px;
  padding: 16px 12px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,.06);
}
@media (min-width: 900px) {
  .adopt-stat {
    flex-direction: row;
    text-align: left;
    justify-content: flex-start;
    gap: 14px;
    padding: 16px 20px;
  }
}
.adopt-stat__ico {
  font-size: 22px;
  color: #555;
  flex-shrink: 0;
}

.adopt-stat__ico--red   { color: #c80002; }
.adopt-stat__ico--green { color: #148050; }
.adopt-stat div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.adopt-stat strong {
  font-size: 22px;
  font-weight: 900;
  color: #111;
  line-height: 1;
}
.adopt-stat span {
  font-size: 11px;
  font-weight: 600;
  color: #888;
}

/* ══════════════════════════════════════
   GRILLE ACTUS + FACEBOOK
══════════════════════════════════════ */
.actu-fb-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: start;
}
@media (max-width: 900px) {
  .actu-fb-grid {
    grid-template-columns: 1fr;
  }
}

.actu-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 600px) {
  .actu-cards {
    grid-template-columns: 1fr;
  }
}

.fb-embed-wrap {
  display: flex;
  justify-content: center;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(0,0,0,.10);
}

/* ══════════════════════════════════════
   BLOC ACTUALITÉS
══════════════════════════════════════ */
.news-block {
  background: #fff;
  padding: 52px 0 44px;
}
.news-wrap {
  max-width: 75%;
  margin: 0 auto;
  padding: 0 28px;
}

/* En-tête */
.news-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}
.news-head__left {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.news-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 13px;
  border-radius: 999px;
  background: rgba(32, 106, 203, 0.1);
  color: #c80002;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .04em;
  text-transform: uppercase;
  width: fit-content;
}
.news-title {
  margin: 0;
  font-size: clamp(22px, 2.8vw, 34px);
  font-weight: 900;
  letter-spacing: -.025em;
  color: #111;
}
.news-cta-link {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 11px 18px;
  border-radius: 12px;
  background: #f7f7f8;
  border: 1.5px solid #e0e0e0;
  color: #111;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
  transition: border-color .15s, box-shadow .15s;
}
.news-cta-link:hover { border-color: #bbb; box-shadow: 0 4px 14px rgba(0,0,0,.08); }

/* Grille */
.news-grid {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr;
  grid-template-rows: 360px;
  gap: 14px;
}
@media (max-width: 1024px) {
  .news-grid {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 280px 280px;
  }
  .ncard--big { grid-column: span 2; }
}
@media (max-width: 600px) {

  .news-wrap {
    max-width: 95%;
    margin: 0 auto;
    padding: 0 28px;
  }

  .news-grid {
    grid-template-columns: 1fr;
    grid-auto-rows: 260px;
  }
  .ncard--big { grid-column: span 1; }
  .ncard--small { grid-row: auto; }

  .adopt-wrap {
    max-width: 95%;
    margin: 0 auto;
    padding: 0 28px;
  }
}

/* Cards */
.ncard {
  position: relative;
  border-radius: 22px;
  overflow: hidden;
  background: #ddd;
  background-size: cover;
  background-position: center;
  text-decoration: none;
  display: flex;
  align-items: flex-end;
  transition: transform .2s, box-shadow .2s;
}
.ncard:hover { transform: translateY(-3px); box-shadow: 0 12px 32px rgba(0,0,0,.14); }

.ncard--small { grid-row: 1; }

.ncard__shade {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0,0,0,.04) 30%, rgba(0,0,0,.72) 100%);
}
.ncard__body {
  position: relative;
  z-index: 2;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.ncard__tag {
  display: inline-flex;
  align-self: flex-start;
  padding: 5px 10px;
  border-radius: 999px;
  background: rgba(255,255,255,.15);
  border: 1px solid rgba(255,255,255,.2);
  backdrop-filter: blur(8px);
  color: rgba(255,255,255,.9);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: .03em;
  text-transform: uppercase;
}
.ncard__title {
  margin: 0;
  color: #fff;
  font-weight: 800;
  font-size: 15px;
  line-height: 1.3;
  text-shadow: 0 2px 8px rgba(0,0,0,.3);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.ncard--big .ncard__title { font-size: 20px; }
.ncard__read {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: rgba(255,255,255,.8);
  font-size: 12px;
  font-weight: 800;
}
.ncard:hover .ncard__read { color: #fff; }

/* Empty */
.news-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 40px 0;
  color: #aaa;
  font-weight: 600;
}

/* Footer */
.news-footer {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}
.news-cta-wide {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 13px 28px;
  border-radius: 14px;
  background: #111;
  color: #fff;
  font-size: 14px;
  font-weight: 900;
  text-decoration: none;
  transition: transform .15s, box-shadow .15s;
}
.news-cta-wide:hover { transform: translateY(-2px); box-shadow: 0 8px 22px rgba(0,0,0,.18); color: #fff; }

/* ── Info section wrapper ── */
.info-section {
  padding: 48px 0 56px;
  background: #f7f7f8;
}
.info-wrap {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ── Mosaic grid ── */
.info-mosaic {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr;
  grid-template-rows: auto auto;
  gap: 16px;
}
.icard--map { grid-row: span 2; }

@media (max-width: 900px) {
  .info-mosaic { grid-template-columns: 1fr 1fr; }
  .icard--map  { grid-column: span 2; grid-row: span 1; }
}
@media (max-width: 560px) {
  .info-mosaic { grid-template-columns: 1fr; }
  .icard--map  { grid-column: span 1; }
}

/* ── Cards ── */
.icard {
  background: #fff;
  border-radius: 22px;
  padding: 22px;
  box-shadow: 0 4px 18px rgba(0,0,0,.07);
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.icard--map {
  padding: 0;
  overflow: hidden;
}

.icard__head {
  display: flex;
  align-items: center;
  gap: 10px;
}
.icard--map .icard__head {
  padding: 22px 22px 0;
}

.icard__icon {
  width: 46px;
  height: 46px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f3;
  font-size: 18px;
  color: #444;
  flex-shrink: 0;
}
.icard__icon--rose  { background: rgba(220,30,100,.10); color: #c0185a; }
.icard__icon--blue  { background: rgba(30,80,220,.10);  color: #1a44c8; }
.icard__icon--green { background: rgba(20,160,80,.10);  color: #148050; }
.icard__icon--amber { background: rgba(220,140,0,.10);  color: #b88000; }

.icard__label {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #aaa;
}

.icard__val {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.75;
  color: #333;
}

/* ── Map image ── */
.icard__map {
  flex: 1;
  min-height: 300px;
  margin-top: 14px;
}
.icard__map img {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 300px;
  object-fit: cover;
}

/* ── Footnote ── */
.info-footnote {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  margin-top: 28px;
  padding: 14px 20px;
  border-radius: 999px;
  background: #fff;
  border: 1.5px solid #e8e8e8;
  font-size: 14px;
  font-weight: 700;
  color: #555;
}
.info-footnote i { color: #e0185a; }

/* ── Permanent info sections ── */
.permanent-info {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}
.permanent-card {
  display: flex;
  align-items: center;
  gap: 20px;
  background: #fff;
  border-radius: 22px;
  padding: 30px;
  box-shadow: 0 4px 18px rgba(0,0,0,.07);
  max-width: 750px;
  width: 100%;
  flex: 1;  transition: transform .2s, box-shadow .2s;
}
.permanent-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(0,0,0,.12);}
.permanent-icon {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f3;
  font-size: 30px;
  color: #c80002;
}
.permanent-content h3 {
  margin: 0 0 10px 0;
  font-size: 18px;
  font-weight: 800;
  color: #111;
}
.permanent-content p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #555;
  line-height: 1.5;
}
.permanent-content a {
  color: #c80002;
  text-decoration: none;
  font-weight: 700;
}
.permanent-content a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .permanent-info {
    flex-direction: column;
  }
  .permanent-card {
    flex-direction: column;
    text-align: center;
    padding: 20px;
    max-width: 100%;
  }
  .permanent-icon {
    width: 50px;
    height: 50px;
    font-size: 24px;
  }
}
</style>
